import { callApi } from 'utils/api'
import crud from "./_crud";

const actions = crud('module_wizard_rel', 'el wizardmódulorel', 'los wizardmódulosrel');

const getModuleWizardRel = (id) => {
    return async (dispatch, getState) => {
        const state = getState()

        try {
        
            const res = await callApi(`/module_wizard_rel/get_module_wizard_rel/${id}`,{
                method: 'GET',
             
            })
            dispatch({
                type: 'LOAD_MODULE_WIZARD_REL', 
                response: res.body,
            })
            return res.body;
        } catch (error) {}
    }
}


const createModuleWizardRel = (items) => {
    return async (dispatch, getState) => {
        const state = getState()
        try {
            const res = await callApi(`/module_wizard_rel/add_module_wizard_rel`,{
                method: 'POST',
                headers: {
                    // Authorization: state.app.user.token,
                },
                body:JSON.stringify({items}),
                successMessage: 'Se creo la relacion correctamente'
            })
            return res.body

        }
        catch(error){console.log(error)}
        
    }
}
export default {...actions, getModuleWizardRel, createModuleWizardRel}